var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 311.8 311.8",
    style: {
      enableBackground: "new 0 0 311.8 311.8"
    },
    xmlSpace: "preserve",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF9800;stroke:#000000;stroke-width:20;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x23_333333ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.7,17.1c24.2-5.6,50.2-2.9,72.7,7.8c20.6,9.7,38.1,26,49.3,45.8c11.1,19.7,16.3,43.1,13.7,65.6 c-2.7,19.5-11.5,37.5-22.2,53.8c-9.5,14.4-20.8,27.4-31.7,40.7c-18.6,22.5-37.6,44.7-56.6,66.8c-21.9-23.4-43.6-47.1-64.5-71.3 c-14.1-16.2-27.7-33.2-36.4-53c-9.1-19.8-12.2-42.2-9.1-63.8c3-22.7,13.7-44.3,29.6-61C90.2,33.1,109.7,21.9,130.7,17.1  M150.5,73.4c-16.4,1.5-31.7,10.9-40.5,24.8c-7.2,11-10.1,24.7-8.2,37.6c1.9,13.6,9.4,26.3,20.1,34.8c8.7,6.9,19.5,11.1,30.6,11.7 c11,0.7,22.2-2,31.7-7.8c8.7-5.2,15.8-12.9,20.3-21.8c6.3-12.2,7.7-26.7,3.9-39.8c-3.7-13.5-13-25.4-25.2-32.4 C173.4,74.7,161.7,72.2,150.5,73.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.eb913e200ea417eb615bf748258605bb.svg";
export { ForwardRef as ReactComponent };